import React from 'react';

const LeaderboardCellScoresTitle = ({ scoringCourseRound }) => {
    return (
        <div className={'leaderboard__cell leaderboard__cell--title leaderboard__cell--scores'}>
            {
                scoringCourseRound.holePars.map((holePar) => {
                    return (
                        <div className="leaderboard__cell-score-title" key={holePar.holeId}>
                            <div className="leaderboard__cell-title">{holePar.holeId}</div>
                            <div className="leaderboard__cell-title-value">{holePar.par}</div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default LeaderboardCellScoresTitle;
